// import { HttpErrorResponse } from '@angular/common/http';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NotificationService } from '../../services';
import { ModalService } from '../../modules/modal';

// import { MessageModalComponent } from '../message/message-modal.component';

// import { Message } from '../../models';

// import { TranslationConstants } from '../../constants/translation';

export class ComponentWithErrorModal implements OnDestroy {
  protected subscriptions: Subscription[] = [];
  responseErrors: string[] = [];
  // flag for blocking displaying error modal if another modal is open
  isModalOpen: boolean;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  protected listenForErrorMessages(): void {
    // this.subscriptions.push(
    //   this.notificationService.notification$.subscribe((message) => {
    //     this.handleErrors(message);
    //   })
    // );
  }

  // protected handleErrors(response: HttpErrorResponse): void {
  //   if (response.status === 400) {
  //     this.responseErrors.push(response.error.errors.global);
  //   } else {
  //     this.responseErrors.push(TranslationConstants.GLOBAL_SERVER_ERROR);
  //   }
  //   if (!this.isModalOpen) {
  //     this.isModalOpen = true;
  //     this.modalService.openModal({
  //       component: MessageModalComponent,
  //       data: {
  //         title: 'Error',
  //         content: this.responseErrors.join('\n'),
  //       } as Message,
  //       success: () => {
  //         this.isModalOpen = false;
  //       },
  //     });
  //   }
  // }

  protected clearErrorMessages(): void {
    this.responseErrors = [];
  }
}
